<div class="root">
  <h2 mat-dialog-title>Comentarios</h2>
  <form #form class="example-form">
    <!--Comentario-->
    <mat-form-field class="example-full-width" appearance="outline">
      <textarea
        matInput
        [formControl]="commentText"
        [errorStateMatcher]="matcher"
        maxlength="800"
        placeholder="Ingrese un comentario"
        required
        cdkTextareaAutosize
        cdkAutosizeMinRows="10"
        cdkAutosizeMaxRows="15"
      ></textarea>
      <mat-hint align="start"><strong></strong></mat-hint>
      <mat-hint align="end"
        >{{ commentText.value?.length ? commentText.value?.length : 0 }} /
        800</mat-hint
      >
    </mat-form-field>

    <mat-dialog-actions>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!formGroup.valid || disable"
        (click)="onSubmit()"
      >
        Guardar
      </button>
      <button mat-button color="primary" (click)="onClose()">Cerrar</button>
    </mat-dialog-actions>
  </form>
  <mat-dialog-content class="comment-dialog" [ngClass] = "{'none': totalComments == 0}">
    <mat-list
      class="comment-container"
      *ngFor="let comment of comments; index as i"
      infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
    >
      <mat-card class="matCard">
        <div class="container">
          <label class="commentUserInfo"
            ><mat-icon>perm_identity</mat-icon>{{ comment.userName }}</label
          >
          <label class="commentDateInfo">
            {{ comment.createdAt | date:'dd/MM/yyyy' }}</label
          >
        </div>

        <hr />
        <mat-list-item-content
          class="commentBox"
          [ngClass]="{
            'show-less': !showShortComment,
            'show-more': showShortComment
          }"
          >{{
            showShortComment
              ? comment.comment
              : (comment.comment | slice: 0:100)
          }}
          <span *ngIf="!showShortComment && comment.comment.length > 100"> ... </span
          ><a
            href="javascript:;"
            (click)="alterCommentText()"
            *ngIf="comment.comment.length > 100"
            >{{ showShortComment ? "Leer menos " : "Leer más" }}
          </a>
        </mat-list-item-content>
      </mat-card>
    </mat-list>
  </mat-dialog-content>
</div>
